import React, { Fragment, useRef } from 'react';
import LoginModal from '../../LoginModal';
import { useState, useEffect } from 'react';
import { authActions } from '../../../store/auth-slice';
import { dealAction } from '../../../store/deal-slice';
import NavItem from '../../Atoms/NavItem/index';
import FaBars from '@meronex/icons/fa/FaBars';
import FaTimes from '@meronex/icons/fa/FaTimes';
import { getConfig, routePathMap } from '../../../utils/config';
import setAuthToken from '../../../utils/authtoken';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { formatCoins, getFormattedUserName } from '../../../helpers';
import { deleteWinnreAuthToken } from '../../../utils/axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { coinSvg, giftBoxSvg, profileSvg } from '../../../commonSVG';
import useBookingSummary from '../../../Hooks/use-bookingSummary';
import BiUser from '@meronex/icons/bi/BiUser';
function DropDownNavBar({ cartCount }) {
    const config = getConfig();
    const isGodrej =
        config?.clientId ===
        'a5f774aefbfdad058bae1f580a2295ee5ea319cd0eb94833db348e5815e77826';
    const history = useHistory();
    const [showNavBar, setShowNavBar] = useState(false);
    const [showMMenu, setShowMMenu] = useState(false); //s
    const [clicked, setClicked] = useState(false); //s
    const [openMyProfile, setOpenMyProfile] = useState(false);
    const [hideLogin, setHideLogin] = useState(false);
    const [isCartVisible, setIsCartVisible] = useState(false);
    const [openMobileDropdown, setOpenMobileDropdown] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();

    const { getUserAccountSummary } = useBookingSummary();

    const { userName, userRole, isAuthenticated, isLoginModalVisible } =
        useSelector((state) => state.auth);
    const reloyRewardPoints = useSelector(
        (state) => state.auth.reloyRewardPoints
    );

    const profileDropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                profileDropdownRef.current &&
                !profileDropdownRef.current.contains(event.target)
            ) {
                setOpenMyProfile(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        setOpenMyProfile(false);
    }, [location.pathname]);

    useEffect(() => {
        if (!isAuthenticated) return;

        const storedPoints = localStorage.getItem('reloyRewardPoints');

        if (storedPoints) {
            dispatch(authActions.setReloyRewardPoints(Number(storedPoints)));
        }

        getUserAccountSummary();
    }, [isAuthenticated]);

    useEffect(() => {
        window.addEventListener('scroll', transitionNavBar);

        return () => {
            window.removeEventListener('scroll', transitionNavBar);
        };
    }, []);
    useEffect(() => {
        if (location.pathname.includes('/surveyform')) setHideLogin(true);
    }, [location.pathname]);

    useEffect(() => {
        const isRewardStore =
            location?.pathname?.toLowerCase()?.includes('rewardstore') ||
            location?.pathname?.toLowerCase()?.includes('rewardpointstore');
        setIsCartVisible(isRewardStore);
    }, [location.pathname]);

    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };
    // console.log('render navbar');
    const logout = () => {
        // localStorage.removeItem('token');
        if (config?.autoLogout) {
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('accessToken');
        } else {
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('cartData_reloyrewardpoints');
            localStorage.removeItem('reloyRewardPoints');
        }
        // setAuthToken(false);
        window?.webengage?.track('LogOut');
        window?.webengage?.user?.logout();
        deleteWinnreAuthToken();
        dispatch(authActions.logout());
    };

    const handleClicks = () => {
        setClicked((prevState) => !prevState);

        if (clicked) {
            setShowMMenu(false);
        } else {
            setShowMMenu(true);
        }
    };

    const setClickFalse = () => {
        setOpenMobileDropdown(false);
    };

    const transitionNavBar = () => {
        // alert(window.scrollY);
        if (window.scrollY > 100) {
            setShowNavBar(true);
        } else {
            setShowNavBar(false);
        }
    };

    const handleCartClick = () => {
        if (cartCount > 0) {
            dispatch(dealAction.setCartModalVisible(true));
            window?.webengage?.track('DealViewedInCart');
            window.dispatchEvent(new Event('cartUpdated'));
        }
    };

    const routeList = window.reloy_env.client_config.NAVIGATION_ROUTES;
    const NAV_ITEMS = [
        {
            key: 'OVERVIEW',
            label: 'OVERVIEW',
            show: () => routeList?.OVERVIEW?.show,
            onClick: () => history.push('/')
        },
        {
            key: 'PROJECTS',
            label: 'PROJECTS',
            show: () => routeList?.PROJECTS?.show,
            // onClick: () =>
            //     history.push(routeList?.PROJECTS?.path || '/projects')
            onClick: () => {
                if (isAuthenticated) {
                    history.push(routeList?.PROJECTS?.path || '/projects');
                } else {
                    history.push(
                        `${location.pathname}?postLoginUrl=${routeList?.PROJECTS?.path || '/projects'}`
                    );
                    openLoginModal();
                }
            }
        },
        {
            key: 'DEALS',
            label: 'CONCIERGE',
            show: () => routeList?.OFFERS?.show,
            // onClick: () => history.push(routeList?.OFFERS?.path || '/deals')
            onClick: () => {
                if (isAuthenticated) {
                    history.push(routeList?.OFFERS?.path || '/deals');
                } else {
                    history.push(
                        `${location.pathname}?postLoginUrl=${routeList?.OFFERS?.path || 'deals'}`
                    );
                    openLoginModal();
                }
            }
        },
        {
            key: 'MY_CUSTOMERS',
            label: 'MY CUSTOMERS',
            show: () => routeList?.MY_CUSTOMERS?.show,
            onClick: () => {
                if (isAuthenticated) {
                    history.push(
                        routeList?.MY_CUSTOMERS?.path || '/myprofile/customers'
                    );
                } else {
                    history.push(
                        `${location.pathname}?postLoginUrl=${routeList?.MY_CUSTOMERS?.path || '/myprofile/customers'}`
                    );
                    openLoginModal();
                }
            }
        },
        {
            key: 'INVOICE',
            label: 'INVOICE',
            show: () => routeList?.INVOICE?.show,
            onClick: () => {
                if (isAuthenticated) {
                    history.push(
                        routeList?.INVOICE?.path || '/myProfile/invoice'
                    );
                } else {
                    history.push(
                        `${location.pathname}?postLoginUrl=${routeList?.INVOICE?.path || '/myProfile/invoice'}`
                    );
                    openLoginModal();
                }
            }
        },
        {
            key: 'POINTS',
            label: 'Coins Store',
            show: () => routeList?.POINTS?.show,
            // onClick: () => history.push('/rewardPointStore')
            onClick: () => {
                if (isAuthenticated) {
                    history.push('/rewardPointStore');
                } else {
                    history.push(
                        `${location.pathname}?postLoginUrl=/rewardPointStore`
                    );
                    openLoginModal();
                }
            }
        },
        {
            key: 'AGREEMENT',
            label: 'Sign Agreement',
            show: () => config?.showAgreement && !isAuthenticated,
            onClick: openLoginModal
        }
    ];
    // console.log('config?.customHomePage,', config?.customHomePage);

    return (
        <>
            <header
                class={`flex flex-col sticky top-0 z-30 mx-auto lg:items-center lg:justify-between lg:flex-row relative ${showNavBar
                        ? config?.navBarConfig?.stickyHeight
                            ? config?.navBarConfig?.stickyHeight
                            : config?.navBarConfig?.height || 'h-20 '
                        : config?.navBarConfig?.height || 'h-20 '
                    } ${config?.navBarConfig?.font}
            ${showNavBar
                        ? ` ${config?.navBarConfig.stickyNavBar.backgroundColor ||
                        'bg-primary-content'
                        }  ${config?.navBarConfig.stickyNavBar.border
                            ? `${config?.navBarConfig.stickyNavBar.borderClass}`
                            : ``
                        } `
                        : ` ${config.navBarConfig.baseNavBar.backgroundColor ||
                        'bg-transparent'
                        } ${config?.navBarConfig.baseNavBar.border
                            ? `${config?.navBarConfig.baseNavBar.borderClass}`
                            : ''
                        } `
                    }
            `}
            >
                {/* LEFT LOGO */}
                {config?.logoLeft && (
                    <div className=" cursor-pointer flex flex-row px-3 lg:px-0  items-center justify-between h-full ">
                        <div className="flex items-center gap-2 lg:hidden ">
                            <button
                                onClick={() =>
                                    setOpenMobileDropdown((prev) => !prev)
                                }
                                className="lg:hidden rounded-lg focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 50 50"
                                    className={` w-6 h-6 ${config?.navBarConfig.mobileIconColor}`}
                                >
                                    {!openMobileDropdown && (
                                        <path d="M 3 9 A 1.0001 1.0001 0 1 0 3 11 L 47 11 A 1.0001 1.0001 0 1 0 47 9 L 3 9 z M 3 24 A 1.0001 1.0001 0 1 0 3 26 L 47 26 A 1.0001 1.0001 0 1 0 47 24 L 3 24 z M 3 39 A 1.0001 1.0001 0 1 0 3 41 L 47 41 A 1.0001 1.0001 0 1 0 47 39 L 3 39 z"></path>
                                    )}
                                    {openMobileDropdown && (
                                        <path
                                            onClick={() =>
                                                setOpenDropdown(false)
                                            }
                                            d="M 7.7070312 6.2929688 L 6.2929688 7.7070312 L 23.585938 25 L 6.2929688 42.292969 L 7.7070312 43.707031 L 25 26.414062 L 42.292969 43.707031 L 43.707031 42.292969 L 26.414062 25 L 43.707031 7.7070312 L 42.292969 6.2929688 L 25 23.585938 L 7.7070312 6.2929688 z"
                                        ></path>
                                    )}
                                </svg>
                            </button>
                        </div>
                        <Link
                            className="h-full flex justify-center items-center"
                            to="/"
                        >
                            <img
                                src={
                                    showNavBar
                                        ? config?.logoLeft?.stickyUrl ||
                                        config?.logoLeft?.url
                                        : config?.logoLeft?.baseUrl ||
                                        config?.logoLeft?.url
                                }
                                className={
                                    '  object-contain ' +
                                    (showNavBar
                                        ? `${config.logoLeft?.stickyNavBarLogoClass}`
                                        : `${config.logoLeft?.baseNavBarLogoClass}`)
                                }
                            />
                        </Link>

                        <div className="flex block lg:hidden space-x-3 ">
                            {!isAuthenticated && (
                                <button
                                    onClick={openLoginModal}
                                    className={`text-left lg:border-none lg:w-auto lg:mr-6 uppercase text-[14px] lg:text-[12px] xl:text-[14px] ${showNavBar
                                            ? ` ${config.navBarConfig.stickyNavBar.itemClass}`
                                            : ` ${config.navBarConfig.baseNavBar.itemClass}`
                                        }  `}
                                >
                                    <BiUser
                                        className={` w-6 h-6 ${config?.navBarConfig.mobileIconColor}`}
                                    />
                                </button>
                            )}
                            {isAuthenticated && (
                                <NavLink
                                    className={
                                        ` block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                        (showNavBar
                                            ? `${config?.navBarConfig
                                                .stickyNavBar.itemClass ||
                                            'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                            }`
                                            : ` ${config.navBarConfig.baseNavBar
                                                .itemClass ||
                                            'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                            }`)
                                    }
                                    activeClassName={
                                        config.navBarConfig.showActiveLinkColor
                                            ? 'text-secondary-focus'
                                            : ''
                                    }
                                    to="/myprofile/info"
                                    onClick={setClickFalse}
                                >
                                    <BiUser
                                        className={` w-6 h-6 ${config?.navBarConfig.mobileIconColor}`}
                                    />
                                </NavLink>
                            )}
                        </div>
                    </div>
                )}
                {/* NAV */}

                <ul
                    className={` lg:flex lg:items-center lg:justify-center w-full absolute left-0 top-[100%] lg:static lg:left-auto lg:top-auto ${showNavBar
                            ? `${config?.navBarConfig.stickyNavBar.containerClass}`
                            : `${config?.navBarConfig.baseNavBar.containerClass} `
                        }`}
                >
                    <li
                        className={`${openMobileDropdown
                                ? 'flex-col flex animate-dropDownOpen '
                                : 'hidden'
                            } bg-primary-content lg:bg-transparent  text-primary lg:flex-grow py-4 md:py-0 lg:flex md:justify-center lg:items-center lg:flex-row md:mx-auto `}
                    >
                        {NAV_ITEMS.map((item) => {
                            if (!item.show()) return null;
                            return (
                                <button
                                    key={item.key}
                                    onClick={() => {
                                        setClickFalse();
                                        item.onClick && item.onClick();
                                    }}
                                    className={`uppercase flex flex-row items-center px-6 py-2 2xl:px-2 2xl:py-2 lg:pb-2 lg:border-none lg:mr-7 lg:px-0 lg:inline-block transition ease-out duration-75 w-full md:w-auto md:inline
            ${showNavBar ? config?.navBarConfig.stickyNavBar.itemClass : config?.navBarConfig.baseNavBar.itemClass}`}
                                >
                                    {item.label}
                                </button>
                            );
                        })}

                        {isAuthenticated &&
                            (() => {
                                // Create dropdown options array for mobile (same as desktop)
                                const mobileProfileDropdownOptions = [
                                    {
                                        name: 'MY PROFILE',
                                        path: '/myprofile/info',
                                        show: true,
                                        order: 1,
                                        mobileOnly: false
                                    },
                                    {
                                        name: 'Insider Coins',
                                        path: '/myprofile/rewardPoints',
                                        show: routeList?.POINTS?.show,
                                        order: 2,
                                        mobileOnly: false
                                    },
                                    {
                                        name: 'My Orders',
                                        path: '/myprofile/coinStore/Orders',
                                        show: routeList?.POINTS?.show,
                                        order: 3,
                                        mobileOnly: false
                                    },
                                    {
                                        name: 'Logout',
                                        path: null,
                                        show: true,
                                        order: 4,
                                        isAction: true,
                                        action: logout,
                                        mobileOnly: false
                                    }
                                ];

                                return mobileProfileDropdownOptions
                                    .sort((a, b) => a.order - b.order)
                                    .map(
                                        (option) =>
                                            option.show &&
                                            (option.isAction ? (
                                                <button
                                                    key={option.name}
                                                    onClick={option.action}
                                                    className={
                                                        ` text-left px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                                        (showNavBar
                                                            ? `${config
                                                                ?.navBarConfig
                                                                .stickyNavBar
                                                                .itemClass ||
                                                            'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                                            }`
                                                            : ` ${config
                                                                .navBarConfig
                                                                .baseNavBar
                                                                .itemClass ||
                                                            'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                                            }`)
                                                    }
                                                >
                                                    {option.name}
                                                </button>
                                            ) : (
                                                <NavLink
                                                    key={option.name}
                                                    className={
                                                        `px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                                        (showNavBar
                                                            ? `${config
                                                                ?.navBarConfig
                                                                .stickyNavBar
                                                                .itemClass ||
                                                            'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                                            }`
                                                            : ` ${config
                                                                .navBarConfig
                                                                .baseNavBar
                                                                .itemClass ||
                                                            'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                                            }`)
                                                    }
                                                    activeClassName={
                                                        config.navBarConfig
                                                            .showActiveLinkColor
                                                            ? 'text-secondary-focus'
                                                            : ''
                                                    }
                                                    to={option.path}
                                                    onClick={setClickFalse}
                                                >
                                                    {option.name}
                                                </NavLink>
                                            ))
                                    );
                            })()}

                        {!isAuthenticated && (
                            <button
                                onClick={openLoginModal}
                                className={`text-left px-6 w-full py-2  lg:border-none lg:w-auto lg:mr-6 uppercase ${showNavBar
                                        ? ` ${config.navBarConfig.stickyNavBar.itemClass}`
                                        : ` ${config.navBarConfig.baseNavBar.itemClass}`
                                    } lg:p-0
                                     `}
                            >
                                Login/Register
                            </button>
                        )}
                    </li>
                </ul>
                <div className="hidden lg:flex items-center">
                    {isAuthenticated && routeList?.POINTS?.show && (
                        <div className="hidden lg:flex items-center ml-auto">
                            <div
                                className={
                                    'flex items-center gap-2 transition ease-out duration-75 cursor-pointer'
                                }
                                onClick={() => {
                                    history.push('/rewardPointStore');
                                }}
                            >
                                <div className="flex items-center justify-center">
                                    {coinSvg()}
                                </div>
                                <div className="flex flex-col text-left text-primary">
                                    <span
                                        className={`font-semibold  font-Forum ${showNavBar
                                                ? ` ${config.navBarConfig.stickyNavBar.itemClass}`
                                                : ` ${config.navBarConfig.baseNavBar.itemClass}`
                                            }`}
                                    >
                                        {formatCoins(
                                            reloyRewardPoints != null
                                                ? reloyRewardPoints
                                                : 0
                                        )}
                                    </span>
                                    <div
                                        className={`flex flex-col items-start
                                            ${showNavBar
                                                ? ` ${config.navBarConfig.stickyNavBar.itemClass}`
                                                : ` ${config.navBarConfig.baseNavBar.itemClass}`
                                            }`}
                                    >
                                        <span className="font-Forum">
                                            Coins
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {isAuthenticated &&
                        (() => {
                            const profileDropdownOptions = [
                                {
                                    name: 'MY PROFILE',
                                    path: '/myprofile/info',
                                    show: true,
                                    order: 1
                                },
                                {
                                    name: 'INSIDER COINS',
                                    path: '/myprofile/rewardPoints',
                                    show: routeList.POINTS?.show,
                                    order: 2
                                },
                                {
                                    name: 'MY ORDERS',
                                    path: '/myprofile/coinStore/Orders',
                                    show: routeList?.POINTS?.show,
                                    order: 3
                                },
                                {
                                    name: 'LOGOUT',
                                    path: null,
                                    show: true,
                                    order: 4,
                                    isAction: true,
                                    action: logout
                                }
                            ];
                            // Nav item styling follows the same sticky/base
                            // switch as the navbar and this dropdown's own
                            // background.
                            const navItemClass =
                                (showNavBar
                                    ? config?.navBarConfig?.stickyNavBar
                                          ?.itemClass
                                    : config?.navBarConfig?.baseNavBar
                                          ?.itemClass) || 'text-primary';
                            return (
                                <div
                                    className="hidden lg:inline-block relative"
                                    ref={profileDropdownRef}
                                >
                                    {/* Profile Icon Button */}
                                    <button
                                        onClick={() =>
                                            setOpenMyProfile(!openMyProfile)
                                        }
                                        className="flex items-center lg:mr-7"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 57.04 57.04"
                                            className={`h-8 w-8 `}
                                        >
                                            <g>
                                                <path
                                                    fill="currentColor"
                                                    className={navItemClass}
                                                    d="M28.52,0C12.77,0,0,12.77,0,28.52s12.77,28.52,28.52,28.52,28.52-12.77,28.52-28.52S44.27,0,28.52,0ZM28.52,8.69c5.65,0,10.24,4.58,10.24,10.24s-4.58,10.24-10.24,10.24-10.24-4.58-10.24-10.24h0c0-5.65,4.58-10.24,10.24-10.24ZM45.63,42.79c-7.88,9.45-21.93,10.73-31.38,2.85-1.03-.86-1.99-1.81-2.85-2.85-.57-.69-.79-1.61-.57-2.48.97-3.94,3.23-7.44,6.41-9.95.98-.77,2.34-.79,3.34-.05,2.12,1.57,4.89,2.53,7.93,2.53s5.81-.95,7.93-2.53c1-.74,2.37-.72,3.34.05,3.19,2.51,5.44,6.01,6.41,9.95.22.87,0,1.79-.56,2.48h0Z"
                                                />
                                            </g>
                                        </svg>

                                        <svg
                                            className={`w-4 h-4 transition-transform duration-200 ml-1 ${openMyProfile
                                                    ? 'rotate-180'
                                                    : ''
                                                }`}
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>

                                    {/* Dropdown Panel */}
                                    <div
                                        className={`absolute right-0 mt-6 w-56 shadow-xl text-center p-6
                                            transform transition-all duration-300 origin-top text-primary text-md font-semibold
                                            ${showNavBar
                                                ? ` ${config?.navBarConfig
                                                    .stickyNavBar
                                                    .backgroundColor ||
                                                'bg-primary-content'
                                                }  ${config?.navBarConfig
                                                    .stickyNavBar
                                                    .border
                                                    ? `${config?.navBarConfig.stickyNavBar.borderClass}`
                                                    : ``
                                                } `
                                                : ` ${config.navBarConfig
                                                    .baseNavBar
                                                    .backgroundColor ||
                                                'bg-transparent'
                                                } ${config?.navBarConfig
                                                    .baseNavBar.border
                                                    ? `${config?.navBarConfig.baseNavBar.borderClass}`
                                                    : ''
                                                } `
                                            }
                                            ${openMyProfile
                                                ? 'opacity-100 scale-100 translate-y-0'
                                                : 'opacity-0 scale-95 -translate-y-2 pointer-events-none'
                                            }`}
                                    >
                                        {/* Profile Info */}

                                        <p
                                            className={`text-lg font-semibold ${navItemClass}`}
                                        >
                                            {getFormattedUserName(userName)}
                                        </p>
                                        {routeList.POINTS?.show &&
                                            reloyRewardPoints != null && (
                                                <div>
                                                    <p className="text-sm font-semibold">
                                                        You have collected
                                                    </p>

                                                    <p className="text-2xl font-bold mt-1">
                                                        {formatCoins(
                                                            reloyRewardPoints !=
                                                                null
                                                                ? reloyRewardPoints
                                                                : 0
                                                        )}
                                                    </p>

                                                    <p className="text-sm font-semibold">
                                                        Loyalty Coins
                                                    </p>

                                                    <button
                                                        className="my-3 px-4 py-1 border-2 border-primary text-sm text-primary transition font-semibold"
                                                        onClick={() =>
                                                            history.push(
                                                                '/rewardPointStore'
                                                            )
                                                        }
                                                    >
                                                        REDEEM NOW
                                                    </button>
                                                </div>
                                            )}

                                        {/* Menu Items */}
                                        <div className="py-1">
                                            {profileDropdownOptions
                                                .sort(
                                                    (a, b) => a.order - b.order
                                                )
                                                .map(
                                                    (option, index) =>
                                                        option.show &&
                                                        (option.isAction ? (
                                                            <a
                                                                key={
                                                                    option.name
                                                                }
                                                                onClick={
                                                                    option.action
                                                                }
                                                                className={`block py-2 bg-transparent md:mt-0 cursor-pointer ${navItemClass}`}
                                                            >
                                                                {option.name}
                                                            </a>
                                                        ) : (
                                                            <NavLink
                                                                key={
                                                                    option.name
                                                                }
                                                                to={option.path}
                                                                className={`block py-2 bg-transparent md:mt-0 cursor-pointer ${navItemClass}`}
                                                            >
                                                                {option.name}
                                                            </NavLink>
                                                        ))
                                                )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })()}

                    {isAuthenticated &&
                        routeList?.POINTS?.show &&
                        isCartVisible && (
                            <button
                                onClick={handleCartClick}
                                className={`relative hidden lg:block text-left border-none w-auto mr-5 mb-2 `}
                            >
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 22.427 25.887"
                                    className={`w-5 -mb-1 text-primary`}
                                >
                                    <g
                                        id="bag"
                                        transform="translate(-3.005 -0.995)"
                                    >
                                        <path
                                            id="Path_7704"
                                            data-name="Path 7704"
                                            d="M25.427,21.792,23.864,6.771A2.583,2.583,0,0,0,21.291,4.45H18.444a4.314,4.314,0,0,0-8.455,0H7.142A2.581,2.581,0,0,0,4.57,6.77L3,21.792v.086a5.01,5.01,0,0,0,5,5H20.428a5.01,5.01,0,0,0,5-5A.767.767,0,0,0,25.427,21.792ZM14.217,2.725A2.593,2.593,0,0,1,16.657,4.45H11.776a2.593,2.593,0,0,1,2.441-1.726Zm6.212,22.432H8A3.279,3.279,0,0,1,4.726,21.92L6.286,6.952a.863.863,0,0,1,.856-.776H21.291a.863.863,0,0,1,.863.776L23.707,21.92a3.278,3.278,0,0,1-3.278,3.236Z"
                                            transform="translate(0 0)"
                                        />
                                        <path
                                            id="Path_7705"
                                            data-name="Path 7705"
                                            d="M18.765,11a.863.863,0,0,0-.863.863,2.588,2.588,0,0,1-5.177,0,.863.863,0,1,0-1.726,0,4.314,4.314,0,0,0,8.628,0A.863.863,0,0,0,18.765,11Z"
                                            transform="translate(-1.097 -1.373)"
                                        />
                                    </g>
                                </svg>
                                <span className="absolute w-[20px] h-[20px] border rounded-xl bottom-[10px] text-center bg-primary text-white left-[10px] text-xs font-medium">
                                    {cartCount}
                                </span>
                            </button>
                        )}
                </div>
            </header>
        </>
    );
}

export default DropDownNavBar;
